import { compose, createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import thunkMiddleware from 'redux-thunk';

import { reducer } from './reducer';

export default props => {
  const errors = {};
  const initialFormData = {
    formName: 'WarrantyClaim',
    country: props.country || 'US',
    countrySelected: 'US',
    propertyClaimedBy: '',
    validContractorEmail: false,
    contractorEmail: '',
    showRoofInstallDate: false,
    showCurrentPropertyOwner: false,
    showNewContractorForm: false,
    showInvitePropertyOwner: false,
    showNoAvailableWarray: false,
    showRepAssistance: false,
    showGroudLevelExposed: false,
    showExistingClaimPage: false,
    showDIY: false,
    proofOfRoofPurchase: null,
    proofOfOwnerShip: null,
    groundLevelFrontHome: null,
    groundLevelBackHome: null,
    affectedAreaWideAngle: null,
    affectedAreaCloseUp: null,
    ventIntakePhoto: null,
    ventExhaustPhoto: null,
    shingleBack: null,
    shingleFront: null,
    releaseTape: null,
    shingleSample: null,
    fasteners: null,
    havePaperWorkForPropertyOwner: '',
    photoUploadBy: '',
    shinglesUploadBy: '',
    correctPropertyOwner: '',
    roofInstallDate: {
      year: '',
      month: '',
      day: '',
    },
    warrantyRegistrationNumber: '',
    propertyOwner: '',
    contactInfo: {
      email: '',
      phone: '',
      preferredContactMethods: [],
    },
    roofExperiencing: '',
    roofExperiencingComments: '',
    propertyOwnerInvite: '',
    contractorInvite: '',
    propertyOwnerEmail: '',
    propertyAddress: {
      street: '',
      streetLine2: '',
      city: '',
      state: '',
      zip: '',
    },
    newContractorInfo: {
      firstName: '',
      lastName: '',
      company: '',
      phone: '',
      street: '',
      streetLine2: '',
      city: '',
      state: '',
      zip: '',
    },
    selections: 'suggested',
    showManualEntry: false,
    installingContractor: '',
    installingContractorData: '',
    foundContractor: false,
    memberId: '',
  };

  const initialState = {
    railsProps: props,
    step: 0,
    formData: initialFormData,
    appData: {
      documentsCount: 0,
      photosCount: 0,
    },
    appErrors: errors,
    dataComplaints: {},
    showComplaints: false,
    isFetching: false,
    completedSteps: { 0: true },
    metadata: {},
    showModal: false,
    showLeakingModal: false,
    disableSubmitBtn: false,
  };

  const middlewares = [thunkMiddleware];

  if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
  }

  const store = createStore(reducer, initialState, applyMiddleware(...middlewares));

  return store;
};
